
import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { AddTaskForm } from './AddTaskForm';
import { Task } from '@/types/task';

interface EditTaskDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  task: Task;
  onSubmit: (data: any) => void;
}

export const EditTaskDialog = ({ open, onOpenChange, task, onSubmit }: EditTaskDialogProps) => {
  const handleSubmit = (data: any) => {
    const updatedData = {
      ...data,
      isRecurring: !!data.isRecurring,
      recurringFrequency: data.isRecurring ? data.recurringFrequency : null,
      recurringDays: data.isRecurring ? data.recurringDays : [],
      requiresImage: !!data.requiresImage,
    };
    onSubmit(updatedData);
  };

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh]" onClick={handleContentClick} dir="rtl">
        <DialogTitle className="sr-only">עריכת משימה</DialogTitle>
        <ScrollArea className="h-full max-h-[calc(90vh-4rem)] pr-4">
          <AddTaskForm onSubmit={handleSubmit} initialData={task} />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
